function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 263 115"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#3160AA",
  d: "M0 0h263v115H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25 16h80c5.5 0 10 4.5 10 10v63.3c0 5.5-4.5 10-10 10H25c-5.5 0-10-4.5-10-10V26c0-5.5 4.5-10 10-10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#E86F23",
  strokeWidth: "5",
  d: "M25 18.5h80c4.1 0 7.5 3.4 7.5 7.5v63.3c0 4.1-3.4 7.5-7.5 7.5H25c-4.1 0-7.5-3.4-7.5-7.5V26c0-4.1 3.4-7.5 7.5-7.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M158 16h80c5.5 0 10 4.5 10 10v63.3c0 5.5-4.5 10-10 10h-80c-5.5 0-10-4.5-10-10V26c0-5.5 4.5-10 10-10z"
}), /*#__PURE__*/React.createElement("text", {
  fill: "#6D6B6D",
  transform: "translate(30.06 64)",
  fontFamily: "Muli",
  fontSize: "14",
  fontWeight: "700"
}, "This is me!"), /*#__PURE__*/React.createElement("text", {
  fill: "#6D6B6D",
  transform: "translate(166.36 54)",
  fontFamily: "Muli",
  fontSize: "14",
  fontWeight: "700"
}, "This isn't"), /*#__PURE__*/React.createElement("text", {
  fill: "#6D6B6D",
  transform: "translate(167.66 72)",
  fontFamily: "Muli",
  fontSize: "14",
  fontWeight: "700"
}, "really me"), /*#__PURE__*/React.createElement("path", {
  stroke: "#6C8FC6",
  d: "M131.5 18.5v80"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-7161 -4786)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "7226.5",
  cy: "4867.5",
  r: "3.5",
  fill: "#E86F23"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "translate(541 485)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "6685.5",
  cy: "4382.5",
  r: "7.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "6685.5",
  cy: "4382.5",
  r: "7",
  stroke: "#E86F23"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7226.7 4867c-2.4 0-4.3 1.9-4.3 4.3v9.2c-.7-.4-1.4-.6-2.2-.6a4.27 4.27 0 00-3.4 6.9l6.4 8.6c.8 1.1 2.1 1.7 3.4 1.7h12c1.5 0 2.8-1 3.1-2.4l1.5-6.2c.3-1.2.5-2.5.5-3.8v-3.6c0-2.1-1.7-3.8-3.8-3.8-.3 0-.6 0-.9.1a4.2 4.2 0 00-3.1-1.5c-.6 0-1.1.1-1.7.4-.8-.7-1.8-1.2-2.9-1.2h-.5v-3.7c.2-2.4-1.7-4.4-4.1-4.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7226.7 4869.1c1.2 0 2.2 1 2.1 2.2v9.5h.5v-1.6c0-1.2.9-2.1 2.1-2.1 1.2 0 2.2 1 2.1 2.2v1.5h.5v-1.1c0-1 .8-1.9 1.9-1.9 1 0 1.9.9 1.9 1.9v1h.5c0-.9.7-1.6 1.6-1.6.9 0 1.6.8 1.6 1.7v3.6c0 1.1-.1 2.2-.4 3.2l-1.5 6.2c-.1.5-.6.8-1 .8h-12c-.7 0-1.3-.3-1.7-.9l-6.4-8.6c-.3-.4-.4-.8-.4-1.3 0-1.2.9-2.1 2.1-2.1.7 0 1.4.3 1.8.9l2.5 3.4v-15c.1-.9 1-1.9 2.2-1.9zm0-2.1c-2.4 0-4.3 1.9-4.3 4.3v9.2c-.7-.4-1.4-.6-2.2-.6a4.27 4.27 0 00-3.4 6.9l6.4 8.6c.8 1.1 2.1 1.7 3.4 1.7h12c1.5 0 2.8-1 3.1-2.4l1.5-6.2c.3-1.2.5-2.5.5-3.8v-3.6c0-2.1-1.7-3.8-3.8-3.8-.3 0-.6 0-.9.1a4.2 4.2 0 00-3.1-1.5c-.6 0-1.1.1-1.7.4-.8-.7-1.8-1.2-2.9-1.2h-.5v-3.7c.2-2.4-1.7-4.4-4.1-4.4zm2.2 23.6h-.5v-6.4h.5v6.4zm4.2 0h-.5v-6.4h.5v6.4zm4.3 0h-.5v-6.4h.5v6.4z"
}))));